import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';

import * as moment from 'moment';
import AppSelector from './AppSelector';
import { createMuiTheme, ThemeProvider, withStyles } from '@material-ui/core/styles';

require('moment/locale/ja');

moment.locale('ja');


const theme = createMuiTheme({
  palette: {
    // primary: {
    //   light: '#ff795b',
    //   main: 'rgb(223, 70, 48)',
    //   dark: '#a60006',
    //   contrastText: '#fff',
    // },
    // secondary: {
    //   light: '#ffdf64',
    //   main: '#ffad31',
    //   dark: '#c77e00',
    //   contrastText: '#fff',
    // },
  },
});

const GlobalCss = withStyles({
  // @global is handled by jss-plugin-global.
  '@global': {
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    '.App .MuiDialogTitle-root': {
      // padding: '0px',
      // paddingBottom: '4px',
    },
    '.App .MuiTypography-body1': {
      fontSize: '0.8rem'
    },

    '.App .MuiTypography-caption': {
      color: 'gray'
    },

    '.App .MuiListItemIcon-root': {
      minWidth: '30px'
    },

    '.App .MuiInputBase-input': {
      fontSize: '0.8rem'
    },

    '.App .MuiListItem-root': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },

    '.App .MuiListItemText-secondary': {

      fontSize: '0.75rem'
    },

    '.App .MuiListItemText-multiline': {
      marginTop: '0px',
      marginBottom: '0px',
    },

    '.App .MuiListItem-gutters': {
      paddingLeft: '2px',
      paddingRight: '2px',
    },
    '.App .MuiListSubheader-gutters': {
      paddingLeft: '2px',
      paddingRight: '2px',
    },

    '.App .MuiTableCell-sizeSmall': {
      padding: '4px'
    },
    '.App .MuiTableCell-sizeSmall:last-child': {
      padding: '4px'
    },
    '.App .MuiTableCell-body': {
      padding: '4px',
      fontFamily: 'monospace'
    },
    '.App .MuiTableCell-body .MuiTypography-caption': {
      padding: '4px',
      fontFamily: 'monospace'
    },
    '.App .MuiTableCell-head': {
      padding: '4px',
    },
    '.App .MuiTable-root .MuiButtonBase-root': {
      padding: '4px'
    },
    '.App .MuiInput-input': {
      fontFamily: 'monospace'
    },

    '.App .monospace': {
      fontFamily: 'monospace'
    },

    '.App .monospace .MuiTypography-root': {
      fontFamily: 'monospace'
    },
    '.App .App-Content': {
      maxWidth: '70%',
      minWidth: '368px'
    },
    '.App pre': {
      margin: '0px'
    }

  },
})(() => null);


ReactDOM.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <GlobalCss />
    <AppSelector />
  </ThemeProvider>
  // </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

